import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUpdateComment } from '@/api/mutations/useCommentMutations';
import { BaseButton as Button } from '@/components/BaseButton/BaseButton';
import { useRequiredAppSelector } from '@/hooks';
import { focusField } from '@/utils/helpers';
import { ChatInput } from './Chat.styles';

export const CommentInputUpdateWithButton = (props: { id: number; initialValue?: string; handleCancel: () => void }) => {
    const { id, initialValue = '', handleCancel } = props;
    const { t } = useTranslation();
    const projectId = useRequiredAppSelector('projectId');
    const ref = useRef<HTMLInputElement>(null);
    const [value, setValue] = useState(initialValue);

    const { mutateAsync: updateCommentAsync, status: statusUpdate } = useUpdateComment();

    useEffect(() => {
        if (ref?.current) {
            focusField(ref.current);
        }
    }, []);

    const handleSubmit = async () => {
        if (statusUpdate === 'pending') {
            return;
        }

        const { success } = await updateCommentAsync({
            project_id: projectId,
            comment_id: id,
            data: { text: value },
        });
        if (success) {
            handleCancel();
        }
    };

    return (
        <div className="flex flex-wrap w-full gap-[12px]">
            <div className="sm:grow-0 sm:basis-[100%] sm:max-w-[100%]">
                <ChatInput
                    onKeyPress={e => {
                        if (e.ctrlKey && e.code === 'Enter') {
                            handleSubmit();
                        }
                    }}
                    inputRef={ref}
                    multiline
                    placeholder={t('comment.enter-text')}
                    value={value}
                    onChange={e => setValue(e.target.value)}
                />
            </div>

            <div className="flex flex-wrap w-full sm:grow-0 sm:basis-[100%] sm:max-w-[100%] justify-between">
                <Button variant="outlined" onClick={handleSubmit}>
                    {t('buttons.edit')}
                </Button>
                <Button variant="outlined" onClick={handleCancel}>
                    {t('buttons.cancel')}
                </Button>
            </div>
        </div>
    );
};
